import { useEffect, useState } from 'react';
import { useOrientationOverride } from 'contexts/OrientationOverrideContext';

export type Orientation = 'landscape' | 'portrait';

/**
 * Hook that returns current viewport orientation.
 * If an OrientationOverrideContext is set (e.g. in multi-table grid),
 * the override takes precedence over the actual viewport.
 */
export function useOrientation(): Orientation {
  const override = useOrientationOverride();

  const [orientation, setOrientation] = useState<Orientation>(
    window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait'
  );

  useEffect(() => {
    const handleResize = () => {
      setOrientation(
        window.innerWidth >= window.innerHeight ? 'landscape' : 'portrait'
      );
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return override ?? orientation;
}
